import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { resolve } from '../../helpers/LinkMapper';


const defaults = {
    id: null,
    amount: 0,
    expiry: null,
    caseReference: null,
    customer: null,
    voucherId: null,
    type: null,
    code: null,
    campaignName: null,
    campaignTerms: null,
};


class Voucher extends record(defaults) {

    static fromJSON (json = {}) {
        const voucherId = resolve(json.id).with(Number);
        const customer = resolve(json.customer).with(Number);
        const id = customer
            ? `/customers/${customer}/vouchers/${voucherId}`
            : `/vouchers/${voucherId}`;
        const campaign = json.campaign || {};
        return new Voucher({
            id,
            voucherId,
            customer,
            amount: resolve(json.amount).with(Number),
            expiry: resolve(json.expiry).with(trainTime),
            caseReference: resolve(json.caseReference).with(String),
            type: resolve(json.type).with(String),
            code: resolve(campaign.code).with(String),
            campaignName: resolve(campaign.name).with(String),
            campaignTerms: resolve(campaign.terms).with(String),
        });
    }

}


export default Voucher;
